module.exports = __webpack_public_path__ + "01_short_black.ee9ce74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_short_black.png
// module id = thJJ
// module chunks = 0